import { combineReducers, Reducer } from "@reduxjs/toolkit";
import dialogReducer from "@utils/redux-utils/reducers/dialogReducer";
import productReducer from "@utils/redux-utils/reducers/productReducer";
import userReducer from "@utils/redux-utils/reducers/userReducer";
import testReducer from "@store/tests/testSlice";
import patientReducer from "@store/patients/patientSlice";
import uiReducer from "@store/ui/uiSlice";
import analyticsReducer from "@store/analytics/analyticsSlice";
import testListReducer from "@store/testList/testListSlice";
import testSessionListReducer from "@store/testSessionList/testSessionListSlice";
import connectionReducer from "@store/connection/connectionSlice";
import testSessionReducer from "@store/testsession/testSessionSlice";
import testSuiteReducer from "@store/testSuite/testSuiteSlice";
import userPreferencesReducer from "@store/userPreferences/userPreferencesSlice";
import licenceReducer from "@store/licence/licenceSlice";
import adminConfigurationsReducer from "@store/adminConfigurations/adminConfigurationsSlice";
import { RESET_STATE } from "@utils/redux-utils/constants";

// Define the combined reducer
const appReducer = combineReducers({
  product: productReducer,
  user: userReducer,
  dialog: dialogReducer,
  test: testReducer,
  patient: patientReducer,
  ui: uiReducer,
  analytics: analyticsReducer,
  testList: testListReducer,
  testSessionList: testSessionListReducer,
  connection: connectionReducer,
  testSession: testSessionReducer,
  testSuite: testSuiteReducer,
  userPreferences: userPreferencesReducer,
  licence: licenceReducer,
  adminConfigurations: adminConfigurationsReducer,
});

type AppState = ReturnType<typeof appReducer>;

export const rootReducer = ((state, action) => {
  if (action.type === RESET_STATE) {
    const userPreferences = state?.userPreferences;
    const persistedConfiguration = state?.test?.persistedConfiguration;
    const savedConfiguration = state?.test?.savedConfiguration;

    const resetState = appReducer(undefined, action);
    state = {
      ...resetState,
      ...(userPreferences ? { userPreferences } : {}),
      test: {
        ...resetState.test,
        persistedConfiguration: persistedConfiguration ?? resetState.test.persistedConfiguration,
        savedConfiguration: savedConfiguration ?? resetState.test.savedConfiguration,
      },
    };
  }

  return appReducer(state, action);
}) as Reducer<AppState, any>;
